import React from 'react';
import {ModalMethods} from '../../../../../shared/components/modal';
import {ApplicationModal} from './ApplicationModal';
import {EsiaRegCardForm} from '../form/model';
import {NavigationProp, ParamListBase} from '@react-navigation/native';
import {loginStepSlice} from '../../../../../redux/reducers/runtime/loginStep';
import {LoginState} from '../../../../../shared/models/login/loginStep';
import {loginSlice} from '../../../../../redux/reducers/login';
import {Screens} from '../../../../../shared/routing';
import {Dispatch} from 'redux';
import {Platform} from 'react-native';
import {enterCardActivationSession} from '../../../../../redux/actions/cardActivation';

type showModalParams = {
  modals: ModalMethods;
  dispatch: Dispatch<any>;
  isLogged: boolean;
  isDesktop: boolean;
  navigation: NavigationProp<ParamListBase> | undefined;
  formValues: EsiaRegCardForm;
  message?: string;
  redirectToActivation?: boolean;
};

export function ShowResultModal(params: showModalParams) {
  params.modals.show({
    render(modal, methods) {
      const onClose = () => {
        methods.remove(modal.id);
        if (!params.message && params.formValues) {
          if (params.redirectToActivation) {
            if (params.isLogged) {
              params.dispatch(enterCardActivationSession());
            } else {
              params.dispatch(loginSlice.actions.setEsiaUserHasNoCards(true));
              params.dispatch(loginStepSlice.actions.setLoginStep(LoginState.esiaRegCardUnconfirmed));

              if (!params.isDesktop || Platform.OS !== 'web') {
                params.navigation?.navigate(Screens.EsiaActivateCard);
              }
            }
            return;
          }

          if (params.formValues.isAccountLinkingEnabled && params.isLogged) {
            if (Platform.OS === 'web') {
              params.navigation?.navigate(Screens.DesktopProfileMe);
            } else {
              params.navigation?.navigate(Screens.Profile);
              params.navigation?.navigate(Screens.ProfileLinkedAccounts);
            }
          } else params.modals.clear();
        }
      };
      return <ApplicationModal onClose={onClose} message={params.message} />;
    },
    mobile: true,
  });
}
